import * as React from "react";
import { useState } from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { AccountTransfersCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersCollection";
import { AccountTransfersSort } from "../../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersSort";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { sortDirection, Table } from "../../../../../../../Shared/Table/Table";
import { Contents } from "../../Insights/Resource/Contents";

interface IAccountTransfersProps {
    data: AccountTransfersCollection;
    onTableChange: (sortBy, orderByAESC, minrow, maxrow) => void;
}

export const AccountTransfers = (props: IAccountTransfersProps) => {
    if (!props.data) {return null;}

    const [sortBy, setSortBy] = useState(AccountTransfersSort.Date);
    const [dateOrderByAESC, setDateOrder] = useState(false);
    const [amountOrderByAESC, setAmountOrder] = useState(false);
    const [currentPage, setCurPage] = useState(1);

    const getData = (currentPage, sortBy, orderByAESC) => {
        const minrow = (currentPage - 1) * 10 + 1;
        const maxrow = currentPage * 10;
        props.onTableChange(sortBy, orderByAESC, minrow, maxrow);
    };

    const getMoneyFormat = (val: number): string => {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
        if (val < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    };

    return props.data && props.data.Items.length < 1 ? (
        <Alert alertType={AlertType.Warning} message={Contents.noDataErrorMessage} />
    ) : (
        <div className="pt-24">
            <div className="mb-50">
                <Table
                    data={props.data.Items}
                    col={[
                        {
                            title: "Date",
                            key: "LedgerDate",
                            thCssWrapper: "ctable-sort",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                            },
                            sorter: () => {
                                if (sortBy !== AccountTransfersSort.Date) {
                                    setSortBy(AccountTransfersSort.Date);
                                }
                                setDateOrder(!dateOrderByAESC);
                                getData(currentPage, AccountTransfersSort.Date, !dateOrderByAESC);
                            },
                            sortDirection: dateOrderByAESC ? sortDirection.ASC : sortDirection.DESC,
                        },
                        {
                            title: "Product",
                            key: "ProductDisplayName",
                        },
                        {
                            title: "Narrative",
                            key: "Narrative",
                        },
                        {
                            title: "Amount",
                            key: "Amount",
                            thCssWrapper: "ctable-sort cell-right",
                            tdCssWrapper: "cell-right",
                            render: (data, row, index) => {
                                return getMoneyFormat(data);
                            },
                            sorter: () => {
                                if (sortBy !== AccountTransfersSort.Amount) {
                                    setSortBy(AccountTransfersSort.Amount);
                                }
                                setAmountOrder(!amountOrderByAESC);
                                getData(currentPage, AccountTransfersSort.Amount, !amountOrderByAESC);
                            },
                            sortDirection: amountOrderByAESC ? sortDirection.ASC : sortDirection.DESC,
                        },
                    ]}
                    TotalBody={[
                        { data: "Total", colSpan: 3 },
                        {
                            data: getMoneyFormat(
                                props.data.Items.reduce((total, ele) => {
                                    return total + ele.Amount;
                                }, 0)
                            ),
                            tfTdCssWrapper: "cell-right",
                        },
                    ]}
                    needPagination={{
                        totalNumOfResult: props.data.TotalRows,
                        currentPage: currentPage,
                        onPaginationChange: (pageIndex, pageSize) => {
                            setCurPage(pageIndex);
                            getData(
                                pageIndex,
                                sortBy,
                                sortBy == AccountTransfersSort.Amount ? amountOrderByAESC : dateOrderByAESC
                            );
                        },
                    }}
                />
            </div>
        </div>
    );
};
